import React, { useEffect, useState } from 'react'
import { MetaWrapper } from '@components/Meta'
import Page from './Page'
import { WholesaleRegistrationFormData } from './WholesaleRegistrationForm'
import { useSnackbar } from 'notistack'
import { ErrorFragment } from '@graphql/fragments/__generated__/Error.generated'
import { useHistory } from 'react-router-dom'
import { WHOLESALE_ROUTES } from '../../../urls'
import { useWholesaleAppCreateMutation } from '@graphql/mutations/__generated__/wholesale-app.generated'
import { useTranslation } from 'react-i18next'
import { useMeQuery } from '@graphql/queries/__generated__/me.generated'
import { useQueryParams } from 'use-query-params'
import { GlobalDialogFormsParams } from '@components/GlobalDialogForms'

const View: React.FC = () => {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const [errors, setErrors] = useState<ErrorFragment[]>([])
  const [, setParams] = useQueryParams(GlobalDialogFormsParams)
  const meQueryResult = useMeQuery({ fetchPolicy: 'cache-and-network', nextFetchPolicy: 'cache-first' })

  const [wholesaleCustomerCreate] = useWholesaleAppCreateMutation({
    onCompleted: data => {
      if (data.wholesaleAppCreate.errors.length) {
        setErrors(data.wholesaleAppCreate.errors)
        return
      }
      enqueueSnackbar(t('snackbarMessages.success.wholesaleAppSubmitted', 'Wholesale application has been submitted'), {
        variant: 'success',
      })
      history.push(WHOLESALE_ROUTES.APP_CREATED)
    },
  })

  useEffect(() => {
    if (!meQueryResult.data?.me) {
      setParams({ global_dialog_form: 'signIn' }, 'replaceIn')
    }
  }, [meQueryResult.data?.me])

  const onSubmit = async (values: WholesaleRegistrationFormData) => {
    if (!meQueryResult.data?.me) {
      enqueueSnackbar(t('signInToYourAccount', 'Sign in to your account.'), { variant: 'error' })
      return
    }
    try {
      await wholesaleCustomerCreate({
        variables: {
          wholesaleAppInput: {
            email: values.email,
            storeName: values.storeName,
            storeType: values.storeType,
            storeYear: values.storeYear || null,
            storeDescription: values.storeDescription,
            brands: values.brands,
            websiteUrl: values.websiteUrl,
            instagramUrl: values.instagramUrl,
            facebookUrl: values.facebookUrl,
            initialAddress: {
              country: values.country,
              city: values.city,
              firstName: values.firstName,
              lastName: values.lastName,
            },
          },
        },
      })
    } catch (e) {
      enqueueSnackbar(e.message, { variant: 'error' })
    }
  }

  return (
    <MetaWrapper titleDetails='Wholesale Registration'>
      <Page
        onSubmit={onSubmit}
        errors={errors}
        isAuthenticated={!!meQueryResult.data?.me}
        hasWholesaleApp={!!meQueryResult.data?.me?.wholesaleApp}
        userEmail={meQueryResult.data?.me?.email}
        openSignInForm={() => setParams({ global_dialog_form: 'signIn' }, 'replaceIn')}
      />
    </MetaWrapper>
  )
}

export default View
